import { Chip, FormControl } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const FormControlList = lib.styled(FormControl)`
  width: 100%;
  
  && {
    margin-bottom: 10px;
  }
  [class*='MuiInput-underline-'] {
    &:before, &:after {
      border-bottom: 0.5px solid ${colors.lightGray06};
    }

    &:hover {
      &:before, &:after {
        border-bottom: 0.5px solid ${colors.lightGray06};
      }
    }
  }
  label {
    font-size: 12px;
  }
`;

export const SelectList = lib.styled(Autocomplete)`
  width: 100%;
  && .MuiInputBase-root {
    font-size: 13px;
  }
  && .MuiChip-label {
    margin-top: 3px;
  }
`;

export const ChipList = lib.styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Chips = lib.styled(Chip)`
  margin: 2px;
`;
